import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header.attrs({className: 'header-container'})`
  background: #F9FAFA;
  // padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const HeaderContent = styled.div.attrs({className: 'header-content'})`
  margin: 0 auto;
  padding: 0 5.3%;
  height: auto;
  aspect-ratio: 375/56;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (min-width: 769px) {
    aspect-ratio: auto;
    height: 76px;
  }
`;

const Logo = styled.div.attrs({className: 'logo'})`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const LogoImage = styled.img.attrs({className: 'logp-image'})`
  height: 8vw;
  width: auto;
  vertical-align: bottom;
  @media (min-width: 769px) {
    height: 40px;
  }
`;

const Navigation = styled.nav.attrs({className: 'naviagion'})`
  display: flex;
  align-items: center;
  gap: 30px;
  margin-right: 30px;
  margin-left: auto;


  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link).attrs({className: 'nav-link'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #000000;
  text-decoration: none;
  transition: color 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: #0F3F8E;
  }
`;

const ContactSection = styled.div.attrs({className: 'contact-section'})`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    display: none;
  }
     {
  
     }
`;

const ContactSectionSP = styled.div.attrs({className: 'contact-section'})`
  display:none;

  @media (max-width: 768px) {
    display: flex;
    gap: 4%;
    margin-top: 20px;
  }

  a {
    
  }
`;


const ContactButton = styled.button.attrs({className: 'contact-button'})`
  
  background: #FA2225;
  color: #ffffff;
  border: 1px solid #FA2225;
  border-radius: 26px;
  padding: 10px 33px 11px;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 3.46vw;
  line-height: 1.38;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 140px;

  &:hover {
    background: #ffffff;
    color: #FA2225;
    
  }
    @media (min-width: 769px) {
      font-size: 13px;
    }
`;

const OutlineButton = styled.button.attrs({className: 'online-button'})`
  background: #0F3F8E;
  color: #FFFFFF;
  border: 1px solid #0F3F8E;
  border-radius: 26px;
  padding: 10px 29px 11px;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 3.46vw;
  line-height: 1.38;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 140px;

  &:hover {
    background: #ffffff;
    color: #0F3F8E;
  }

  @media (min-width: 769px) {
      font-size: 13px;
    }
`;

// const MobileMenuButton = styled.button.attrs({className: 'mobile-button'})`
//   display: none;
//   background: none;
//   border: none;
//   font-size: 10vw;
//   cursor: pointer;
//   color: #333333;

//   @media (max-width: 768px) {
//     display: block;
//   }
// `;

const MobileMenuButton = styled.button.attrs<{ $isOpen: boolean }>(props => ({
  className: `mobile-menu-button ${props.$isOpen ? '-isopen' : ''}`.trim(),
}))<{ $isOpen: boolean }>`
  position: relative;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 24px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;

  @media (max-width: 768px) {
    display: flex;
  }

  span {
    display: block;
    width: 100%;
    height: 3px;
    background-color: #333;
    border-radius: 2px;
    transition: all 0.3s ease-in-out;
  }

  /* クラスによるアニメーション制御 */
  &.-isopen {
    span:nth-child(1) { transform: translateY(10.5px) rotate(45deg); }
    span:nth-child(2) { opacity: 0;transform: scale(1.001);}
    span:nth-child(3) { transform: translateY(-10.5px) rotate(-45deg); }
  }
`;


const MobileMenu = styled.div.attrs<{ $isOpen: boolean }>(props => ({
  className: `mobile-menu ${props.$isOpen ? '-isopen' : ''}`.trim(),
}))<{ $isOpen: boolean }>`
  display: none; /* 初期状態は非表示 */
  position: fixed;
  top: 14.933vw;
  left: 0;
  right: 0;
  background: #F9FAFA;
  border-top: 1px solid #E5E5E5;
  padding: 20px;
  z-index: 999;

  /* クラスによる表示制御 */
  &.-isopen {
    display: block;
  }

  /* PCサイズ時の安全対策 */
  @media (min-width: 769px) {
    display: none !important;
  }
`;

const MobileNavLink = styled(Link).attrs({className: 'mobile-nav-link'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 3.46vw;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #000000;
  text-decoration: none;
  transition: color 0.3s ease;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px 0;
  display: block;

  &:hover {
    color: #0F3F8E;
  }
`;

const Header: React.FC = () => {
  // メニューの開閉状態を管理（初期値は false = 閉じている）
const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

// メニューの開閉を反転させる関数（関数型アップデートで安全に切り替え）
const toggleMobileMenu = () => {
  setIsMobileMenuOpen(prev => !prev);
};

// メニューを確実に閉じる関数（リンククリック時などに使用）
const closeMobileMenu = () => {
  setIsMobileMenuOpen(false);
};
  

  return (
    <>
      <HeaderContainer>
        <HeaderContent>
          <Logo>
            <Link to="/">
              <LogoImage src="/images/footer-logo.svg" alt="Lib-Gate Logo" />
            </Link>
          </Logo>
          
          <Navigation>
            <NavLink to="/philosophy/">企業理念</NavLink>
            <NavLink to="/service/">事業紹介</NavLink>
            <NavLink to="/information/">お知らせ</NavLink>
            <NavLink to="/company/">企業情報</NavLink>
            <NavLink to="/privacy-policy/">プライバシーポリシー</NavLink>
          </Navigation>
          
          <ContactSection>
            <a href="/contact/"><OutlineButton>お問合せ</OutlineButton></a>
            <Link to="https://xelenhd.com/careers/">
              <ContactButton>採用情報</ContactButton>
            </Link>
          </ContactSection>
          
          
          <nav>
            <MobileMenuButton 
              $isOpen={isMobileMenuOpen} 
              onClick={toggleMobileMenu}
              aria-label="メニューを開閉する"
              aria-expanded={isMobileMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </MobileMenuButton>
          </nav>
        </HeaderContent>
      </HeaderContainer>
      
      <MobileMenu $isOpen={isMobileMenuOpen}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <MobileNavLink to="/philosophy/" onClick={closeMobileMenu}>企業理念</MobileNavLink>
      <MobileNavLink to="/service/" onClick={closeMobileMenu}>事業紹介</MobileNavLink>
      <MobileNavLink to="/information/" onClick={closeMobileMenu}>お知らせ</MobileNavLink>
      <MobileNavLink to="/company/" onClick={closeMobileMenu}>企業情報</MobileNavLink>
      <MobileNavLink to="/privacy-policy/" onClick={closeMobileMenu}>プライバシーポリシー</MobileNavLink>
      <ContactSectionSP>
        <a href="/contact/">
          <OutlineButton style={{ width: 'auto', flex: 1 }} onClick={closeMobileMenu}>お問合せ</OutlineButton>
        </a>
        <Link to="https://xelenhd.com/careers/">
          <ContactButton style={{ width: 'auto', flex: 1 }} onClick={closeMobileMenu}>採用情報</ContactButton>
        </Link>
      </ContactSectionSP>
    </div>
  </MobileMenu>
    </>
  );
};

export default Header;
